var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row_btn_status"},[(_vm.loginUserInfo.auth_ref_estimate)?_c('div',[(_vm.active === 'request_status01')?_c('span',{staticClass:"btn btn-lg btn-request"},[_vm._v("\n      見積依頼状況\n    ")]):_c('a',{staticClass:"btn btn-lg btn-request",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestStateEstimate',
          'loadHTML_forRequestStateEstimate',
          {},
          '',
          '/requeststate/estimate.html'
        )}}},[_vm._v("見積依頼状況")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_samplecatalogue)?_c('div',[(_vm.active === 'request_status02')?_c('span',{staticClass:"btn btn-lg btn-request"},[_vm._v("\n      サンプル依頼状況\n    ")]):_c('a',{staticClass:"btn btn-lg btn-request",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestStateSampleCatalogue',
          'loadHTML_forRequestStateSampleCatalogue',
          {},
          '',
          '/requeststate/samplecatalogue.html'
        )}}},[_vm._v("サンプル依頼状況")])]):_vm._e(),(_vm.loginUserInfo.auth_ref_envdocument)?_c('div',[(_vm.active === 'request_status03')?_c('span',{staticClass:"btn btn-lg btn-request"},[_vm._v("\n      環境依頼状況\n    ")]):_c('a',{staticClass:"btn btn-lg btn-request",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitAsteria(
          'RequestStateEnvironment',
          'loadHTML_forRequestStateEnvironment',
          {},
          '',
          '/requeststate/environment.html'
        )}}},[_vm._v("環境依頼状況")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }